import React from 'react';
import WidgetReference from './WidgetReference';

export default function EmailService() {
  return (
    <>
      <WidgetReference guideId="email-service" />
    <iframe
      src="https://scribehow.com/o/_ygSvBcHTUyj_X5hGoV2bw/viewer/Updating_Shopify_Email_Sender_Domain_Settings__qsCSH9MLT3SjmQayEr1HZA"
      height="640"
      title="Email Service"
      allowFullScreen
    />
    </>
  );
}
